import { isCookieAuth } from "../lib/authProvider";

import {
  AuthContext as CognitoAuthContext,
  AuthProvider as CognitoAuthProvider,
} from "./CookieAuthContext";
import {
  AuthContext as JWTAuthContext,
  AuthProvider as JWTAuthProvider,
} from "./JWTContext";

const useCognito = isCookieAuth();

export const AuthContext = useCognito ? CognitoAuthContext : JWTAuthContext;
export const AuthProvider = useCognito ? CognitoAuthProvider : JWTAuthProvider;
